<template>
  <div style="height: 100%; position: relative;">
    <DashboardFilterChip :chip-color="chipColor" :chip-text="chipText"></DashboardFilterChip>
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>Perm. Placement Goal</h1>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="6" align="center">
            <h2>Current Month:<br>{{ permPlacementData.currentMonth | currency }}</h2>
          </v-col>
          <v-col cols="6" align="center">
            <h2>Goal:<br>{{ permPlacementData.goal | currency }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn
              text
              color="primary"
              :disabled="disableButtons"
              @click="showDirectPlacementGoalDetails"
            >
              Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              class="ml-2"
              @click="refreshTile"
              style="float: left;"
              >
                <v-icon>refresh</v-icon>
            </v-btn>
            <i
              v-if="showFetchingDataGIF"
              class="mr-2"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-10 mr-5"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <DynamicModal
      :showModal="showDirectPlacementGoalModal"
      :persistent="false"
      @clickOutside="closeDirectPlacementGoalsDetails"
      title="Perm. Placements Payments"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeDirectPlacementGoalsDetails"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <DirectPlacementGoalDetails
          :data="permPlacementData.directPlacementPayments"
        ></DirectPlacementGoalDetails>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <v-row>
          <v-col cols="12">
            <v-btn
              block
              depressed
              outlined
              @click="closeDirectPlacementGoalsDetails"
            >
              Close
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import DashboardFilterChip from '@/components/dashboard/DashboardFilterChip'
import DirectPlacementGoalDetails from './DirectPlacementGoalDetails'
import { mapActions } from 'vuex'
import { isJSONString } from '@/lib/miscellaneous'
import { getLocalTimeString } from '@/lib/display'

export default {
  components: {
    DashboardFilterChip,
    DynamicModal,
    DirectPlacementGoalDetails
  },
  props: {
    chipText: {
      type: String,
      default: 'All Business Entity'
    },
    chipColor: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      showDirectPlacementGoalModal: false,
      permPlacementData: {
        currentMonth: 0,
        goal: 0,
        directPlacementPayments: []
      },
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      disableButtons: false
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getDirectPlacementGoalCurrentMonth'
    ]),
    showDirectPlacementGoalDetails () {
      this.showDirectPlacementGoalModal = true
    },
    closeDirectPlacementGoalsDetails () {
      this.showDirectPlacementGoalModal = false
    },
    refreshTile () {
      this.showFetchingDataGIF = true
      this.disableButtons = true
      this.getDirectPlacementGoalCurrentMonth().then((data) => {
        if (data) {
          let dateTimeNow = new Date()
          this.permPlacementData = data
          localStorage.setItem('dashboard:perm-placement-goal', JSON.stringify(data))
          localStorage.setItem('dashboard:perm-placement-goal-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
        this.disableButtons = false
      })
    }
  },
  created () {
    if (localStorage.getItem('dashboard:perm-placement-goal') && isJSONString(localStorage.getItem('dashboard:perm-placement-goal'))) {
      this.permPlacementData = JSON.parse(localStorage.getItem('dashboard:perm-placement-goal'))
    }
    if (localStorage.getItem('dashboard:perm-placement-goal-last-refresh-time') && isJSONString(localStorage.getItem('dashboard:perm-placement-goal-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:perm-placement-goal-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>
